import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='N. DOC' htmlFor='text-numeroDocumento' md={4} />
      <Col md={8}>
        <Field name='numeroDocumento'>
          {({ field }) => <Form.InputText {...field} id='text-numeroDocumento' disabled={fIsSubmitting} isInvalid={iTouched && iError} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
